import React from 'react';
import { Avatar, Typography } from 'antd';
import type { paydOrder } from '../../interfaces';
import { formatSizeLabel } from '../../../utils/sizeOptions';
import './AdminOrdersItems.scss';

const { Text } = Typography;

interface AdminOrdersItemsProps {
  items: paydOrder['items'];
}

const AdminOrdersItems: React.FC<AdminOrdersItemsProps> = ({ items }) => (
  <div className="admin-orders__items admin-orders__items-scroll">
    {items.map((item) => {
      const imageUrl = item.product?.images?.[0]?.image?.publicUrl;

      return (
        <div key={item.id} className="admin-orders__item">
          <div className="admin-orders__item-main">
            <Avatar
              shape="square"
              size={48}
              src={imageUrl || undefined}
              className="admin-orders__item-avatar"
              style={{ objectFit: 'cover' }}
            >
              {item.product?.title?.[0] || 'P'}
            </Avatar>
            <div className="admin-orders__item-text">
              <Text strong>{item.product?.title || 'Product removed'}</Text>
              <Text type="secondary">Material: {item.material || '—'}</Text>
              <Text type="secondary">Size: {item.size ? formatSizeLabel(item.size) : '—'}</Text>
            </div>
          </div>
          <Text className="admin-orders__item-qty">Qty: {item.quantity}</Text>
        </div>
      );
    })}
  </div>
);

export default AdminOrdersItems;
